import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Link from '@mui/material/Link';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { Avatar, Divider, ListItemIcon, ListItemText, MenuItem, Select } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function Copyright() {
  return (
    <Typography variant="body2" color="text.secondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://mui.com/">
        Your Website
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9];

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme({
  palette: {
    primary: {
      main: '#ff6347',
      contrastText: '#fff'
    },
    secondary: {
      main: '#edf2ff'
    },
  },
});

const getText = (lang) => {

  if (lang == null || lang === '')
    lang = 'en';

  let texts = new Array();
  texts['es'] = {
    Title: <>Borrar cuenta y<br />datos</>,
    subTitle: <>¡Bienvenido! Puedes acceder a nuestra aplicación con usuario y contrase&ntilde;a o como usuario invitado. Si inicias sesion con tus credenciales, tendr&aacute;s una opcion para borrar tu cuenta y datos, o solo tus datos.<br />Si eliges ingresar como invitado, solamente puedes borrar tu cuenta.</>,
    button1: <>Acceder con tus credenciales</>,
    button2: <>Acceder como invitado</>,
    subTitle1: <>Si accedes con credenciales, puedes borrar tu cuenta o datos como sigue:</>,
    option_1_1: <><li>Accede a la opci&oacute;n <b>Settings</b>.</li></>,
    option_1_2: <><li>Selecciona la opci&oacute;n 'My Account'.</li></>,
    option_1_3: <><li>Borra tu cuenta y datos, o solo tus datos.</li></>,
    subTitle2: <>Si accedes como invitado, puedes borrar tu cuenta como sigue:</>,
    option_2_1: <><li>Accede a la opci&oacute;n <b>Settings</b>.</li></>,
    option_2_2: <><li>Selecciona la opci&oacute;n 'My Account'.</li></>,
    option_2_3: <><li>Borra tu cuenta y datos.</li></>,
  };
  texts['en'] = {
    Title: <>Delete account and data</>,
    subTitle: <>Welcome! You can access our app with a username and password or as a guest user. If you log in with your credentials, you have the option to delete your account and your data, or just your data.<br />If you choose to log in as a guest, you can only delete your account.</>,
    button1: <>Log in with your credentials</>,
    button2: <>Log in as a guest</>,
    subTitle1: <>If you log in with your credentials, you can delete your account or data as follows:</>,
    option_1_1: <><li>Access the <b>Settings</b> option.</li></>,
    option_1_2: <><li>Select 'My Account' option.</li></>,
    option_1_3: <><li>Delete your account and data, or just your data.</li></>,
    subTitle2: <>If you log in as a guest, you can delete your account as follows:</>,
    option_2_1: <><li>Access the <b>Settings</b> option.</li></>,
    option_2_2: <><li>Select 'My Account' option.</li></>,
    option_2_3: <><li>Delete your account and data.</li></>,
  };
  texts['pr'] = {
    Title: <>Excluir conta e<br />dados</>,
    subTitle: <>Bem-vindo! Você pode acessar nosso aplicativo com um nome de usuário e senha ou como usuário convidado. Se você fizer login com suas credenciais, tem a opção de excluir sua conta e seus dados, ou apenas seus dados. <br />Se optar por entrar como convidado, só poderá excluir sua conta.</>,
    button1: <>Faça login com suas credenciais</>,
    button2: <>Faça login como convidado</>,
    subTitle1: <>Se você fizer login com suas credenciais, pode excluir sua conta ou dados da seguinte maneira:</>,
    option_1_1: <><li>Acesse a opção <b>Settings</b>.</li></>,
    option_1_2: <><li>Selecione a opção 'My Account'.</li></>,
    option_1_3: <><li>Exclua sua conta e dados ou apenas seus dados.</li></>,
    subTitle2: <>Se você fizer login como convidado, pode excluir sua conta da seguinte maneira:</>,
    option_2_1: <><li>Acesse a opção <b>Settings</b>.</li></>,
    option_2_2: <><li>Selecione a opção 'My Account'.</li></>,
    option_2_3: <><li>Exclua sua conta e dados.</li></>,
  };
  texts['it'] = {
    Title: <>Cancella account e<br />dati</>,
    subTitle: <>Benvenuto! Puoi accedere alla nostra app con un nome utente e una password o come utente ospite. Se accedi con le tue credenziali, hai l'opzione di cancellare il tuo account e i tuoi dati, oppure solo i tuoi dati.<br />Se scegli di accedere come utente ospite, puoi solo cancellare il tuo account.</>,
    button1: <>Accedi con le tue credenziali</>,
    button2: <>Accedi come utente ospite</>,
    subTitle1: <>Se accedi con le tue credenziali, puoi eliminare il tuo account o i tuoi dati nel seguente modo:</>,
    option_1_1: <><li>Accedi all'opzione <b>Settings</b>.</li></>,
    option_1_2: <><li>Seleziona l'opzione 'My Account'.</li></>,
    option_1_3: <><li>Cancella il tuo account e i tuoi dati, o solo i tuoi dati.</li></>,
    subTitle2: <>Se accedi come utente ospite, puoi eliminare il tuo account nel seguente modo:</>,
    option_2_1: <><li>Accedi all'opzione <b>Settings</b>.</li></>,
    option_2_2: <><li>Seleziona l'opzione 'My Account'.</li></>,
    option_2_3: <><li>Cancella il tuo account e i tuoi dati.</li></>,
  };
  texts['fr'] = {
    Title: <>Supprimer le compte<br />et les données</>,
    subTitle: <>Bienvenue ! Vous pouvez accéder à notre application avec un nom d'utilisateur et un mot de passe ou en tant qu'utilisateur invité. Si vous vous connectez avec vos identifiants, vous avez la possibilité de supprimer votre compte et vos données, ou seulement vos données.<br />Si vous choisissez de vous connecter en tant qu'invité, vous ne pourrez supprimer que votre compte.</>,
    button1: <>Connectez-vous avec vos identifiants</>,
    button2: <>Se connecter en tant qu'invité</>,
    subTitle1: <>Si vous vous connectez avec vos identifiants, vous pouvez supprimer votre compte ou vos données comme suit:</>,
    option_1_1: <><li>Accédez à l'option <b>Settings</b>.</li></>,
    option_1_2: <><li>Sélectionnez l'option 'My Account'.</li></>,
    option_1_3: <><li>Supprimez votre compte et vos données, ou seulement vos données.</li></>,
    subTitle2: <>Si vous vous connectez en tant qu'invité, vous pouvez supprimer votre compte comme suit :</>,
    option_2_1: <><li>Accédez à l'option <b>Settings</b>.</li></>,
    option_2_2: <><li>Sélectionnez l'option 'My Account'.</li></>,
    option_2_3: <><li>Supprimez votre compte et vos données.</li></>,
  };

  return texts[lang];
}

export default function App() {

  const [lang, setLang] = React.useState('en');

  const onChangeLanguage = (event) => {
    setLang(event.target.value);
  }

  const Texts = getText(lang);

  return (
    <ThemeProvider theme={defaultTheme}>
      <CssBaseline />
      <AppBar position="relative">
        <Toolbar>
          <Avatar
            alt="Hf+"
            src="./hf_plus.png"
          />
          <Typography variant="h6" color="inherit" noWrap sx={{ marginLeft: '8px' }}>
            Home Finance Plus
          </Typography>
          <Select style={{ position: 'absolute', right: 10, color: '#fff' }} value={lang} onChange={onChangeLanguage}>
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="es">Español</MenuItem>
            <MenuItem value="pr">Português</MenuItem>
            <MenuItem value="it">Italiano</MenuItem>
            <MenuItem value="fr">Français</MenuItem>
          </Select>
        </Toolbar>
      </AppBar>
      <main>
        {/* Hero unit */}
        <Box
          sx={{
            bgcolor: 'background.paper',
            pt: 8,
            pb: 6,
          }}
        >
          <Container maxWidth="sm">
            <Typography
              component="h1"
              variant="h2"
              align="center"
              color="text.primary"
              gutterBottom
            >
              {Texts.Title}
            </Typography>
            <Typography variant={(lang === 'fr' ? 'h6' : 'h5')} align="center" color="text.secondary" paragraph>
              {Texts.subTitle}
            </Typography>
            <Stack
              sx={{ pt: 4 }}
              direction="row"
              spacing={2}
              justifyContent="center"
            >
              <Button variant="contained" style={{ fontSize: (lang === 'fr' ? 10 : undefined) }} href="#with-credentials">{Texts.button1}</Button>
              <Button variant="outlined" style={{ fontSize: (lang === 'fr' ? 10 : undefined) }} href="#as-guest">{Texts.button2}</Button>
            </Stack>
          </Container>
        </Box>
        <Container component="main" sx={{ mt: 1, mb: 2 }} maxWidth="sm" id="with-credentials">
          <Typography variant="h6" component="h2" gutterBottom>
            {Texts.subTitle1}
          </Typography>
          <Typography variant="body1" component="h2">
            <ol type="1">
              {Texts.option_1_1}
              {Texts.option_1_2}
              {Texts.option_1_3}
            </ol>
          </Typography>
          <video width="640" height="480" autoPlay muted loop>
            <source src="delete-account-data-register-user.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </Container>
        <Divider sx={{ marginTop: 4, marginBottom: 4, marginLeft: 5, marginRight: 5 }} />
        <Container component="main" sx={{ mt: 1, mb: 2 }} maxWidth="sm" id="as-guest">
          <Typography variant="h6" component="h2" gutterBottom>
            {Texts.subTitle2}
          </Typography>
          <Typography variant="body1" component="h2">
            <ol type="1">
              {Texts.option_2_1}
              {Texts.option_2_2}
              {Texts.option_2_3}
            </ol>
          </Typography>
          <video width="640" height="480" autoPlay muted loop>
            <source src="delete-account-data-guest-user.webm" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </Container>
      </main>
    </ThemeProvider>
  );
}